import { Button } from "@design-system/Inputs/Button";
import { useTranslation } from "react-i18next";
import { RegularTabs, useEditorContext } from "../hooks/useEditor";
import { AiCheckTab } from "./ReviewSidebar/AiCheckTab";
import InformationBlock from "./ReviewSidebar/InformationBlock";

export default function BottomRightBlock() {
    const {
        version,
        displayAiCheckTab,
        regularModeActiveTab,
        setRegularModeActiveTab,
        aiCheckLoadingProgress,
        setAiCheckLoadingProgress,
    } = useEditorContext();
    const { t } = useTranslation("EditDocument");
    if (!version?.document) return null;
    return (
        <div className="overflow-auto p-4 space-y-4">
            <div className="flex gap-2">
                <Button
                    size="sm"
                    variant="tonal"
                    onClick={() => setRegularModeActiveTab(RegularTabs.INFO)}
                >
                    {t("document_information")}
                </Button>
                {displayAiCheckTab && (
                    <Button
                        size="sm"
                        variant="tonal"
                        onClick={() =>
                            setRegularModeActiveTab(RegularTabs.AI_COACH)
                        }
                    >
                        {t("ai_review")}
                    </Button>
                )}
            </div>
            {regularModeActiveTab === RegularTabs.AI_COACH &&
            displayAiCheckTab ? (
                <AiCheckTab
                    versionId={version.id}
                    aiCheck={version.aiDocumentChecks ?? undefined}
                    aiCheckLoadingProgress={aiCheckLoadingProgress}
                    setAiCheckLoadingProgress={setAiCheckLoadingProgress}
                />
            ) : (
                <InformationBlock
                    documentType={version.document.type}
                    documentDescription={version.document.description}
                />
            )}
        </div>
    );
}
